:host {
    --background-color: var(--button-background-color-dark, transparent);
    --border-color: var(--button-border-color-dark, #{$color-red});
    --typo-color: var(--button-color-dark, #{$color-red});

    @include typo-ws-paragraph-bold-fixed;

    align-items: center;
    justify-content: center;
    background-color: var(--background-color);
    border: 1px solid var(--border-color);
    color: var(--typo-color);
    cursor: pointer;
    display: inline-grid;
    max-width: 100%;
    position: relative;
    box-sizing: border-box;

    ::slotted(*) {
        all: unset;
        color: inherit;
        padding: 12px 32px;
        white-space: nowrap;
    }

    .svg,
    .text {
        grid-area: 1 / 1 / 2 / 2;
    }

    .svg {
        opacity: 0;
        transform: translate3d(2px, 0, 0);
        transition:
            opacity 0.2s,
            transform 0.2s;
        width: 24px;
    }

    .text {
        align-self: stretch;
        display: flex;
        max-width: 100%;
        overflow: hidden;
        transform: translate3d(0, 0, 0);
        transition: transform 0.2s;
    }

    .counter {
        align-items: center;
        background-color: $color-red;
        border: 2px solid $color-white;
        border-radius: 50%;
        color: $color-white;
        display: flex;
        font-size: 12px;
        height: 26px;
        justify-content: center;
        position: absolute;
        right: -14px;
        top: -14px;
        width: 26px;
    }
}

:host([full-width]) {
    display: grid;
    width: 100%;
}

:host([size='small']) {
    ::slotted(*) {
        padding: 8px 32px;
    }
}

:host(.ellipsis) {
    ::slotted(*) {
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

:host(:hover) {
    .svg {
        opacity: 1;
        transform: translate3d(10px, 0, 0);
    }

    .text {
        transform: translate3d(8px, 0, 0);
        transition: transform 0.2s;
    }
}

// selector primary is deprecated
:host([hierarchy='primary']),
:host([hierarchy='filled']) {
    --background-color: #{$color-red};
    --typo-color: #{$color-white};
}

:host(:active:not([disabled])) {
    --border-color: #{$color-red};
    --background-color: #{$color-red};
    --typo-color: #{$color-white};
}

:host([hierarchy='filled']:active:not([disabled])) {
    --border-color: #{$color-red-dark};
    --background-color: #{$color-red-dark};
}

:host([disabled]) {
    border-color: $color-grey-03;
    color: $color-grey-03;
    cursor: auto;

    .svg {
        opacity: 0;
        transform: translate3d(8px, 0, 0);
    }

    .text {
        transform: translate3d(0, 0, 0);
        transition: transform 0.2s;
    }
}

:host(.icon-only) {
    .svg {
        opacity: 1;
        transform: translate3d(10px, 0, 0);
        transition: transform 0.2s ease 0s;

        .shaft {
            opacity: 0;
            transition: opacity 0.2s ease 0s;
        }
    }

    ::slotted(*) {
        width: 48px;
        height: 48px;
        padding: 24px !important;
        box-sizing: border-box;
        overflow: hidden;
        color: transparent;
        user-select: none;
    }
}

:host(.icon-only:hover) {
    .svg {
        transform: translate3d(12px, 0, 0);

        .shaft {
            opacity: 1;
        }
    }

    .text {
        transform: translate3d(0, 0, 0) !important;
    }
}

:host(.icon-only[icon]) {
    .svg {
        transform: translate3d(12px, 0, 0) !important;
    }
}

:host([icon]),
:host(.loading) {
    .svg {
        opacity: 1;
        transform: translate3d(17px, 0, 0);
        transition: transform 0.2s ease 0s;
        width: 24px;
    }

    ::slotted(*) {
        padding-left: 46px;
    }
}

:host([icon]:hover),
:host(.loading) {
    .svg {
        transform: translate3d(17px, 0, 0) scale(1.2);
    }

    .text {
        transform: translate3d(2px, 0, 0);
    }
}

:host([icon='launch']:hover),
:host([icon='download']:hover) {
    .svg {
        transform: translate3d(17px, 0, 0);
    }

    .text {
        transform: translate3d(4px, 0, 0);
    }
}

:host([icon='launch']) {
    .arrow {
        transition: transform 0.2s;
    }
}

:host([icon='launch']:hover) {
    .arrow {
        transform: translate(2px, -2px);
    }
}

@keyframes download-animation {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-3px);
    }
    100% {
        transform: translateY(0);
    }
}

:host([icon='download']:hover) {
    .arrow {
        animation: download-animation 0.5s;
    }
}

@include mq-1 {
    :host(:not(.icon-only)) {
        width: 100%;
    }

    :host(:not(.icon-only):not([icon]):not(.loading)) {
        .svg {
            display: none;
        }
    }

    :host(:hover:not(.loading)) {
        .text {
            transform: translate3d(0, 0, 0);
        }
    }
}

@media print {
    :host {
        border: 1px solid $color-black;
        background-color: transparent;
        color: $color-black;
    }
}

:host(:not([hierarchy='filled']).sew-ws-dark) {
    --button-color-dark: #{$color-white};
    --button-border-color-dark: #{$color-white};
}

:host(.loading) {
    .svg.loading {
        animation: loading-animation 1s linear infinite;
        margin-left: 17px;
    }
}

@keyframes loading-animation {
    from {
        transform: rotate3d(0, 0, 1, 0deg);
    }

    to {
        transform: rotate3d(0, 0, 1, 360deg);
    }
}
